import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  Image,
  TouchableHighlight,
  Linking,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { IconButton } from "../components_v2/Buttons";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import ArTheme from "../argon-ui/Theme";
import { translate, defaultConfig } from "../locales/translate";
import Loading from "../components/Loading";
import { FONT_FAMILIES } from "../../assets/consts/faCharCodes";
import { englishToPersianNumber } from "../util";
const LOGO_SIZE = 80;
const LANG_FA = "fa";
const LANG_EN = "EN";
const INSTAGRAM_IMAGE = "../../assets/images/instagram.png";
const WHATSAPP_IMAGE = "../../assets/images/whatsApp.png";
const GLOBE_IMAGE = "../../assets/images/globe.png";
class AboutUsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // mainText: translate("aboutUs.aboutUsMessage"),
      mainText: defaultConfig.aboutUsMessage,
      // companyInstagramAddress: "taplife.ir",
      // companySiteAddress: "https://taplife.ir/",
      companySiteAddress: defaultConfig.aboutUsWebsite,
      companyPhoneNumber: defaultConfig.aboutUsPhone,
      isLoading: false,
      serverUrl: null,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    // headerTitle: translate("navigation.AboutUs"),
    headerTitle: defaultConfig.aboutUsTitle,
  });
  async componentDidMount() {
    const serverUrl = this.props.AppReducer.serverUrl;
    this.setState({ serverUrl });
    // this.getAboutUsInformationFromServer();
    this.setState({ isLoading: false });
  }
  //get data from DB(taplifeCenter) <settings Table>
  getAboutUsInformationFromServer = () => {
    var serverUrl = this.state.serverUrl;
    var args = [];
    args.push(`lang=${LANG_FA}`);
    var url = `${serverUrl}Info/AboutUsInformation?lang=${LANG_FA}}`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.successful) {
          aboutInfo = resj.message;
          this.setState({
            mainText: aboutInfo.description,
            companyInstagramAddress: aboutInfo.instagramAddress,
            companySiteAddress: aboutInfo.siteAddress,
            companyPhoneNumber: aboutInfo.supportPhoneNumber,
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        {
          console.log(`get data form ${url} error is:${err}`);
          this.setState({ isLoading: false });
        }
      });
  };
  // handle press address by direct to address
  onPressWebAddress = (address) => {
    if (Platform.OS === "web") {
      window.open(address);
    } else {
      Linking.openURL(address);
    }
  };
  //for phone number

  // render item to contact
  showContactItem = (text, icon) => {
    const instagramAddress = "https://www.instagram.com/";
    return (
      <TouchableHighlight
        onPress={() => {
          if (icon == WHATSAPP_IMAGE) {
            this.onPressWebAddress(`tel:${text}`);
          } else if (icon == INSTAGRAM_IMAGE) {
            this.onPressWebAddress(instagramAddress + text);
          } else {
            this.onPressWebAddress(text);
          }
        }}
        style={styles.mainContactStyle}
      >
        <View style={{ flexDirection: "row-reverse", alignItems: "flex-end" }}>
          {icon == faCharCodes.faGlobe && (
            <IconButton
              style={{
                backgroundColor: "#ffffff",
                width: 30,
                height: 30,
                borderRadius: 35,
                borderWidth: 1,
                borderColor: ArTheme.COLORS.BORDER,
                alignItems: "center",
                justifyContent: "center",
              }}
              icon={{
                code: icon,
                style: {
                  fontFamily: FONT_FAMILIES.PRO_REGULAR,
                  fontSize: 18,
                  color: "gray",
                },
              }}
            />
          )}
          {icon == INSTAGRAM_IMAGE && (
            <View
              style={{
                backgroundColor: "#ffffff",
                width: 30,
                height: 30,
                borderRadius: 35,
                borderWidth: 1,
                borderColor: ArTheme.COLORS.BORDER,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image
                source={require("../../assets/images/instagram.png")}
                width={10}
                height={10}
                style={{ width: 22, height: 22 }}
              ></Image>
            </View>
          )}
          {icon == GLOBE_IMAGE && (
            <View
              style={{
                backgroundColor: "#ffffff",
                width: 30,
                height: 30,
                borderRadius: 35,
                borderWidth: 1,
                borderColor: ArTheme.COLORS.BORDER,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image
                source={require("../../assets/images/globe.png")}
                width={10}
                height={10}
                style={{ width: 22, height: 22 }}
              ></Image>
            </View>
          )}
          {icon == WHATSAPP_IMAGE && (
            <View
              style={{
                backgroundColor: "#ffffff",
                width: 30,
                height: 30,
                borderRadius: 35,
                borderWidth: 1,
                borderColor: ArTheme.COLORS.BORDER,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image
                source={require("../../assets/images/whatsApp.png")}
                width={10}
                height={10}
                style={{ width: 22, height: 22 }}
              ></Image>
            </View>
          )}
          <Text style={styles.contactTextStyle}>{text}</Text>
        </View>
      </TouchableHighlight>
    );
  };
  render() {
    if (this.state.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    }
    return (
      <View
        style={{
          flex: 1,
          backgroundColor: ArTheme.COLORS.WHITE,
          paddingHorizontal: 25,
          justifyContent: "space-between",
        }}
      >
        <View style={{ alignItems: "center", justifyContent: "center" }}>
          <View
            style={{
              alignContent: "center",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              flex: 1,
              width: "100%",
              marginBottom: 20,
              paddingTop: Platform.OS != "web" ? 50 : 0,
              paddingBottom: Platform.OS != "web" ? 50 : 0,
            }}
          >
            {/*title */}
            {/* <Text style={{ fontWeight: "bold", fontSize: 25 }}>
              {translate("navigation.AboutUs")}
            </Text> */}
            {/* logo */}
            {/* <Image
              source={require("../../assets/images/icon.png")}
              width={LOGO_SIZE}
              height={LOGO_SIZE}
              style={styles.logo}
            /> */}
          </View>
          {/* text  */}
          <Text
            style={{
              fontSize: 14,

              paddingBottom: 15,
            }}
          >
            {this.state.mainText}
          </Text>
        </View>
        <View style={{ alignItems: "flex-end", marginVertical: 30 }}>
          {/* instagram  address contact */}
          {/* {this.showContactItem(
            this.state.companyInstagramAddress,
            INSTAGRAM_IMAGE
          )} */}
          {/* site address contact */}
          {this.showContactItem(this.state.companySiteAddress, GLOBE_IMAGE)}
          {/* phone contact */}
          {this.showContactItem(this.state.companyPhoneNumber, WHATSAPP_IMAGE)}
        </View>
      </View>
    );
  }
}

function mapStateToProps(state) {
  return {
    AppReducer: state.AppReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const styles = StyleSheet.create({
  mainStyle: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
  mainAboutStyle: { flexDirection: "row", marginEnd: 30, padding: 10 },
  logo: {
    // resizeMode: "contain",
    width: LOGO_SIZE,
    height: LOGO_SIZE,
    marginTop: 10,
    marginEnd: 10,
  },
  mainContactStyle: {
    marginBottom: 5,
    marginStart: 8,
    marginEnd: 8,
  },
  contactTextStyle: {
    paddingEnd: 8,
    paddingStart: 8,
    fontSize: 15,
    fontFamily: "Arial"
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(AboutUsScreen);
